import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpPaymentService } from '../../../apis/http-payment.service';
import { PaymentRequest } from '../../../types/payment/payment-request';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { LoaderService } from '../../../core/services/loader.service';
import { NgOptimizedImage } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PayComponent } from '../pay/pay.component';
import { PaymentStatusComponent } from '../payment-status-component.component';
import { PaymentProcessedComponent } from '../payment-processed/payment-processed.component';
import { HeaderComponent } from '../../../core/components/header/header.component';
import { PaymentRequestType } from '../../../types/payment/payment-request-type';
import { PaymentRequestStatusComponent } from '../payment-request-status/payment-request-status.component';
import { environment } from '../../../../environments/environment';
import { PaymentRequestStatus } from '../../../types/payment/payment-request-status';

@Component({
  selector: 'app-payment-home',
  standalone: true,
  imports: [ReactiveFormsModule, NgOptimizedImage, RouterOutlet, HeaderComponent, PaymentRequestStatusComponent],
  templateUrl: './payment-home.component.html',
  styleUrl: './payment-home.component.less'
})
export class PaymentHomeComponent implements OnInit {
  private paymentRequest: PaymentRequest | undefined;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private api: HttpPaymentService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  onOutletLoaded(component: PayComponent | PaymentProcessedComponent | PaymentStatusComponent) {
    component.request = this.paymentRequest!;
    if (component instanceof PayComponent) {
      component.newRequestStatus.subscribe((v) => {
        this.request.status = v;
      });
    }
  }

  get request(): PaymentRequest {
    return this.paymentRequest!;
  }

  async ngOnInit(): Promise<any> {
    let publicId = this.route.snapshot.paramMap.get('publicId')!;
    if (publicId.length > 16 && environment.shouldTrimPublicId) {
      publicId = publicId.substring(0, 16);
      this.router.navigate([publicId], {
        replaceUrl: true
      });
    }
    try {
      let pr = await this.api.getPaymentRequest(publicId!);
      this.onLoad(pr);
    } catch (exception: any) {
      const status = exception?.status ?? exception?.error?.status;
      if (status === 404 || status === 400) {
        this.router.navigate(['404'], { replaceUrl: false, skipLocationChange: true });
      } else {
        this.router.navigate(['error'], {
          queryParams: {
            publicId: publicId,
            traceId: exception.error?.traceId,
            status: status
          },
          replaceUrl: false,
          skipLocationChange: true
        });
      }
    }
  }

  private onLoad(response: PaymentRequest) {
    this.paymentRequest = response;
    this.loader.hideLoader();
    this.changeDetectorRef.detectChanges();
  }

  protected readonly PaymentRequestType = PaymentRequestType;
  protected readonly PaymentRequestStatus = PaymentRequestStatus;
}
